import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent implements OnInit {
    @Input() disabled?: boolean = false;
    @Input() submitting?: boolean = false;
    @Input() classes: 'primary-default' | 'primary-light' = 'primary-default';
    @Input() icon?: string = '';
    @Input() iconSize?: string = '16px';
    @Input() text: string = '';
    @Input() linkHref: string = '';
    @Input() linkExt: boolean = false;
    @Input() linkTarget: string = '';
    @Output() emitClick = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}
}
